var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-default-comp"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"col2"},[_c('home-circle-chart-empty'),_vm._v(" "),_c('home-circle-chart-kpi')],1),_vm._v(" "),_c('todo-list')],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('home-bar-chart'),_vm._v(" "),_c('tools-list')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b1d5c43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/personalHome/home/homeDefaultComp.vue
// module id = null
// module chunks = 